import { Text } from "@radix-ui/themes";
import { FC, JSX } from "react";

import SamsungHeader from "../../shared/SamsungHeader";

const CountdownHeader: FC = (): JSX.Element => {
  return (
    <SamsungHeader
      lines={["FASTEST LAPS", "ON THE GRID"]}
      subtitle={
        <Text size="2" style={{ color: "#9e9d9d" }}>
          Set the fastest lap and claim your spot on the leaderboard!
        </Text>
      }
    />
  );
};

export default CountdownHeader;
